var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 55,
    viewBox: "0 0 66 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1777",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.501953,
    width: 65.0772,
    height: 54,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1777)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89307 9.77488C1.89307 8.39323 3.01311 7.27319 4.39475 7.27319H50.1977C51.5794 7.27319 52.6994 8.39324 52.6994 9.77488V45.0928C52.6994 46.4745 51.5794 47.5945 50.1977 47.5945H4.39475C3.01311 47.5945 1.89307 46.4745 1.89307 45.0928V9.77488ZM4.39475 9.14946C4.04934 9.14946 3.76933 9.42947 3.76933 9.77488V45.0928C3.76933 45.4382 4.04934 45.7182 4.39475 45.7182H50.1977C50.5431 45.7182 50.8232 45.4382 50.8232 45.0928V9.77488C50.8232 9.42947 50.5431 9.14946 50.1977 9.14946H4.39475Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2478 41.5497C62.2478 47.3404 57.5535 52.0347 51.7628 52.0347C45.9721 52.0347 41.2778 47.3404 41.2778 41.5497C41.2778 35.759 45.9721 31.0647 51.7628 31.0647C57.5535 31.0647 62.2478 35.759 62.2478 41.5497Z",
    fill: "#F3BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.761 32.0025C46.4884 32.0025 42.2142 36.2768 42.2142 41.5494C42.2142 46.822 46.4884 51.0962 51.761 51.0962C57.0336 51.0962 61.3079 46.822 61.3079 41.5494C61.3079 36.2768 57.0336 32.0025 51.761 32.0025ZM40.3379 41.5494C40.3379 35.2405 45.4522 30.1262 51.761 30.1262C58.0699 30.1262 63.1842 35.2405 63.1842 41.5494C63.1842 47.8582 58.0699 52.9725 51.761 52.9725C45.4522 52.9725 40.3379 47.8582 40.3379 41.5494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8346 33.6089C52.3527 33.6089 52.7728 34.0289 52.7728 34.547V40.5514H56.6733C57.1914 40.5514 57.6114 40.9715 57.6114 41.4896C57.6114 42.0077 57.1914 42.4277 56.6733 42.4277H50.8965V34.547C50.8965 34.0289 51.3165 33.6089 51.8346 33.6089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89307 20.4442C1.89307 19.9261 2.31308 19.5061 2.8312 19.5061H51.7613C52.2794 19.5061 52.6994 19.9261 52.6994 20.4442C52.6994 20.9624 52.2794 21.3824 51.7613 21.3824H2.8312C2.31308 21.3824 1.89307 20.9624 1.89307 20.4442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3175 2.03149C13.8356 2.03149 14.2557 2.45151 14.2557 2.96963V13.4546C14.2557 13.9728 13.8356 14.3928 13.3175 14.3928C12.7994 14.3928 12.3794 13.9728 12.3794 13.4546V2.96963C12.3794 2.45151 12.7994 2.03149 13.3175 2.03149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6685 28.1193C19.6685 28.6374 19.2485 29.0574 18.7303 29.0574L13.3166 29.0575C12.7985 29.0575 12.3785 28.6375 12.3785 28.1194C12.3785 27.6012 12.7985 27.1812 13.3166 27.1812L18.7303 27.1812C19.2484 27.1811 19.6685 27.6012 19.6685 28.1193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6685 37.9196C19.6685 38.4377 19.2485 38.8577 18.7303 38.8577L13.3166 38.8578C12.7985 38.8578 12.3785 38.4378 12.3785 37.9197C12.3785 37.4015 12.7985 36.9815 13.3166 36.9815L18.7303 36.9814C19.2484 36.9814 19.6685 37.4015 19.6685 37.9196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9482 28.1193C30.9482 28.6374 30.5282 29.0574 30.0101 29.0574L24.5964 29.0575C24.0783 29.0575 23.6583 28.6375 23.6583 28.1194C23.6582 27.6012 24.0783 27.1812 24.5964 27.1812L30.0101 27.1812C30.5282 27.1811 30.9482 27.6012 30.9482 28.1193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9482 37.9196C30.9482 38.4377 30.5282 38.8577 30.0101 38.8577L24.5964 38.8578C24.0783 38.8578 23.6583 38.4378 23.6583 37.9197C23.6582 37.4015 24.0783 36.9815 24.5964 36.9815L30.0101 36.9814C30.5282 36.9814 30.9482 37.4015 30.9482 37.9196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.229 28.1193C42.229 28.6374 41.809 29.0574 41.2909 29.0574L35.8772 29.0575C35.359 29.0575 34.939 28.6375 34.939 28.1194C34.939 27.6012 35.359 27.1812 35.8771 27.1812L41.2909 27.1812C41.809 27.1811 42.229 27.6012 42.229 28.1193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.229 37.9196C42.229 38.4377 41.809 38.8577 41.2909 38.8577L35.8772 38.8578C35.359 38.8578 34.939 38.4378 34.939 37.9197C34.939 37.4015 35.359 36.9815 35.8771 36.9815L41.2909 36.9814C41.809 36.9814 42.229 37.4015 42.229 37.9196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2956 2.03149C27.8137 2.03149 28.2337 2.45151 28.2337 2.96963V13.4546C28.2337 13.9728 27.8137 14.3928 27.2956 14.3928C26.7774 14.3928 26.3574 13.9728 26.3574 13.4546V2.96963C26.3574 2.45151 26.7774 2.03149 27.2956 2.03149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.276 2.03149C41.7941 2.03149 42.2142 2.45151 42.2142 2.96963V13.4546C42.2142 13.9728 41.7941 14.3928 41.276 14.3928C40.7579 14.3928 40.3379 13.9728 40.3379 13.4546V2.96963C40.3379 2.45151 40.7579 2.03149 41.276 2.03149Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.826c0cc55f05ef7121c4f419f02b69dc.svg";
export { ForwardRef as ReactComponent };